import * as React from "react";
import { CourseType } from "../../types/entitiesModel";
import { fetchCourses } from "../../utils/Utils";
import {
  Alert,
  Autocomplete,
  Box,
  Card,
  CircularProgress,
  Grid,
  TextField,
} from "@mui/material";

interface CourseSelectFormNoSendType {
  selectionCourse: CourseType | null;
  setSelectionCourse: (course: CourseType | null) => void;
}

const CourseSelectFormNoSend: React.FC<CourseSelectFormNoSendType> = (
  props: CourseSelectFormNoSendType
) => {
  const [courses, setCourses] = React.useState<CourseType[]>([]);
  const [error, setError] = React.useState<string | null>(null);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    fetchCourses(setLoading, setCourses, setError);
  }, []);

  return (
    <>
      {!loading && courses.length > 0 ? (
        <Grid container spacing={0} sx={{ width: "100%" }}>
          <Card variant="outlined" sx={{ p: 2, width: "100%" }}>
            {error && (
              <Alert sx={{ mx: "auto", my: 2, width: "95%" }} severity="error">
                {error}
              </Alert>
            )}
            <Autocomplete
              options={courses}
              getOptionLabel={(option: CourseType) => option.group_name}
              onChange={(event, newValue) => {
                props.setSelectionCourse(newValue || null);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Curso"
                  variant="outlined"
                  fullWidth
                  placeholder="Selecciona un curso"
                />
              )}
              value={props.selectionCourse || null}
            />
          </Card>
        </Grid>
      ) : (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100vh"
        >
          <CircularProgress />
        </Box>
      )}
    </>
  );
};

export default CourseSelectFormNoSend;
